/**
 * STACKED_GROUPED_BAR_TOP_CHART_SCHEMA: a JSON object representing a schema used to drive the top chart in the
 * mobile view for the scenario analysis.
 */
export const STACKED_GROUPED_BAR_TOP_CHART_CONFIG = {
	chart: {
		spacing: 0,
		marginTop: 80,
		spacingBottom: 0,
		backgroundColor: null,
		style: {
			fontFamily: '12px "FortBook", Arial, sans-serif',
			color: '#4A4A4A'
		},
		type: 'bar',
		height: 200
	},
	plotOptions: {
		series: { stacking: 'normal' },
		bar: {
			pointWidth: '25',
			groupPadding: 0.9,
			pointPadding: 0
		}
	},
	xAxis: {
		labels: {
			enabled: false
		},
		visible: false
	},
	yAxis: {
		title: {
			text: 'Sensitivity %',
			style: {
				color: '#000',
				font: '12px "FortBook", Arial, sans-serif'
			},
			margin: 10
		},
		visible: true,
		opposite: true,
		min: 0,
		max: 0,
		offset: 30
	},
	colors: null,
	title: {
		text: null
	},
	extensibleData: null
};
